import { connect } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import "../layout/Spinner.css";
import { Dropdown } from "semantic-ui-react";
import { useState, useEffect } from "react";
let sportList = null;
const ClassYearDropDown = (props) => {
  const [classYears, setClassYears] = useState([]);

  useEffect(() => {
    if (props.adminAthletes && props.athletes) {
      const admin = props.adminAthletes.map((athlete) => athlete.class);
      const nonAdmin = props.athletes.map((athlete) => athlete.class);
      const committed = props.adminAthletes
        .filter((athlete) => athlete.committed)
        .map((athlete) => athlete.class);
      const classYear = props.admin
        ? admin
        : props.commit
        ? committed
        : nonAdmin;
      const unique = classYear.filter((v, i, a) => a.indexOf(v) === i);
      const sorted = unique.sort((a, b) => (a > b ? -1 : b > a ? 1 : 0));
      const years = sorted.filter((year) => !isNaN(year));
      const strings = sorted.filter((year) => isNaN(year));
      const merged = [...years, ...strings];
      const options = merged.map((year, i) => {
        return {
          key: i,
          text: year === "college_transfer" ? "College Transfer" : year,
          value: year,
          disabled:
            year === "college_transfer" ? props.disabledCollegeTransfer : false,
        };
      });
      setClassYears(options);
    }
  }, [props.athletes, props.adminAthletes, props.admin, props.commit]);

  sportList = (
    <Dropdown
      {...props}
      options={classYears}
      selection
      fluid
      placeholder={props.placeholder}
      value={props.value}
      name={props.name}
      onChange={props.onChange}
    />
  );
  if (!isLoaded(classYears) && classYears.length > 0) {
    return (
      <Dropdown
        loading
        placeholder={props.placeholder}
        name={props.name}
        {...props}
      />
    );
  } else {
    return sportList;
  }
};

const mapStateToProps = (state) => {
  return {
    adminAthletes: state.firestore.ordered.adminAthletes,
    athletes: state.firestore.ordered.athletes,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "adminAthletes",
    },
    {
      collection: "athletes",
    },
  ])
)(ClassYearDropDown);
